/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Common_RecommendedInputs */

const en_wc_common_recommended = /** @type {(inputs: Wc_Common_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Wc_Common_RecommendedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_common_recommended = /** @type {((inputs?: Wc_Common_RecommendedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Common_RecommendedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_common_recommended(inputs)
});
export { wc_common_recommended as "wc.common.recommended" }